if (!customElements.get('simple-bundles')) {
  class SimpleBundles extends HTMLElement {
    constructor() {
      super();
    }

    handleChange(event) {
      const target = event.target;
      const select = document.getElementById(target.getAttribute('name'));

      if (!select) return;

      select.value = target.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));

      const span = this.querySelector(`[js-current-value="${target.getAttribute('js-index')}"]`);
      if (!span) return;

      span.textContent = select.value;
    }

    connectedCallback() {
      this.addEventListener('change', this.handleChange.bind(this));
    }
  }

  customElements.define('simple-bundles', SimpleBundles);
}
